import { openBlock as t, createElementBlock as r, createElementVNode as s, normalizeStyle as o } from "vue";
import { _ as l } from "./_plugin-vue_export-helper-dad06003.js";
const p = {
  props: {
    progress: {
      type: String,
      default: "0%"
    }
  }
}, f = { class: "relative h-0.5 w-full ct-bg-3" };
function u(a, n, e, c, d, i) {
  return t(), r("div", f, [
    s("div", {
      class: "absolute h-full top-0 left-0 bg-gray-900 dark:bg-white",
      style: o({ width: e.progress })
    }, null, 4)
  ]);
}
const b = /* @__PURE__ */ l(p, [["render", u]]), _ = {
  props: {
    progress: {
      type: String,
      default: "0%"
    }
  }
}, g = { class: "relative h-2 w-full ct-bg-3 rounded-full overflow-hidden" };
function h(a, n, e, c, d, i) {
  return t(), r("div", g, [
    s("div", {
      class: "absolute h-full top-0 left-0 bg-gray-900 dark:bg-white rounded-full",
      style: o({ width: e.progress })
    }, null, 4)
  ]);
}
const v = /* @__PURE__ */ l(_, [["render", h]]);
export {
  b as B,
  v as a
};
